import React from "react";
import "./App.css";
import "react-datepicker/dist/react-datepicker.css";
import "./assets/style/Common.scss";
import "./assets/style/CustomVariables.scss";
import "react-toastify/dist/ReactToastify.css";
import { Routing } from "./routing";
import { BrowserRouter as Router } from "react-router-dom";
import { ProSidebarProvider } from "react-pro-sidebar";

function App() {
  return (
    <div className="App">
      <ProSidebarProvider>
        <Router>
          <Routing />
        </Router>
      </ProSidebarProvider>
    </div>
  );
}

export default App;
